import { ConfigProvider, Pagination } from "antd";
import "./styles.scss";
import faIR from "antd/lib/locale/fa_IR";

export default function DBPagination(props) {
    return (
        <ConfigProvider direction="rtl" locale={faIR}>
            <Pagination
                {...props}
                className="db-pagination"
                showSizeChanger={false}
                showLessItems
                pageSize={20}
            />
        </ConfigProvider>
    );
}
